<template>
	<div class="filter-summary flex-middle" v-if="!isEmpty">
		<div class="level container is-mobile">
			<div class="level-left">
				<div class="level-item is-hidden-mobile" v-if="!backLink" aria-live="polite">
					{{pageElementRange.start}}-{{pageElementRange.end}} of {{currentPage.totalResults}} results 
					<template v-if="isFiltered">
						for&nbsp;<span v-html="filterString"></span>
					</template>
				</div>
				<div class="level-item" v-if="backLink">
					<a :href="backLink.url">Back to {{backLink.label}}</a>
				</div>
				
				<div class="level-item" v-if="!backLink && isFiltered && !showFilterModal">
					<a href="#" role="button" class="clear-all" v-on:click.stop="clearFilters" aria-label="Clear all filters">Clear All</a>
				</div>
			</div>
			<div class="level-right" :class="{ 'is-open': showFilterModal}">
				<div class="level-item is-hidden-mobile">
					<div class="select">
						<select v-model="sort" aria-label="Sort Options" @change="sortChanged">
							<option v-for="option in productSortOptions" :value="option.value">{{option.label}}</option>
						</select>
					</div>
				</div>

				<div class="level-item is-hidden-tablet">
					<span  @click="setShowFilterModal(true)" @keyup.enter="setShowFilterModal(true)" tabindex="0" class="sliders has-text-weight-bold">
						<i class="fas fa-sliders-h"></i>
						Filter
					</span>
          <collapse-transition>
            <div class="mobile-filters" v-if="showFilterModal">
              <div class="mobile-clear-filters has-text-centered" v-if="isFiltered">
                <a role="button" href="#" class="clear-all" v-on:click.stop="clearFilters" aria-label="Clear all filters">Clear All</a>
              </div>
              <div class="filter-option" v-for="facet in currentPage.facets" v-if="facet.populated">
                <multiselect-button v-model="facet.selected" :name="facet.name" :options="facet.values" :is-large="true" :is-bold="true" @select-changed="search"></multiselect-button>
              </div>
              <div class="sort-option">
                <div class="select is-large is-fullwidth mb-4">
                  <select v-model="sort" aria-label="Sort Options" @change="sortChanged">
                    <option v-for="option in productSortOptions" :value="option.value">{{option.label}}</option>
                  </select>
                </div>
              </div>
              <button class="button is-black is-fullwidth is-large" @click="setShowFilterModal(false)">Done</button>
            </div>
          </collapse-transition>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
import {CollapseTransition} from "vue2-transitions";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";

import MultiselectButton from "../MultiselectButton.vue";

export default {
	name: "SearchResultsSummary",
	components: { MultiselectButton, CollapseTransition },
	computed: {
		...mapState("search", ["currentPage", "backLink"]),
		...mapGetters("search", ["isEmpty", "pageElementRange", "productSortOptions", "isFiltered", "showFilterModal"]),
		...mapFields("search", ["sort"]),
	},
	
	methods: {
		...mapActions("search", ["clearFilters", "sortChanged", "search"]),
    ...mapMutations("search", ["setShowFilterModal"]),
	},

}
</script>